
import React from 'react';
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface SidebarToggleProps {
  collapsed: boolean;
  toggleSidebar: () => void;
}

export const SidebarToggle: React.FC<SidebarToggleProps> = ({ collapsed, toggleSidebar }) => {
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleSidebar}
      className={cn(
        "absolute top-4 -right-3 h-6 w-6 rounded-full",
        "border border-sidebar-border bg-sidebar backdrop-blur-sm",
        "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground",
        "text-sidebar-foreground transition-colors duration-150",
        collapsed ? "rotate-180" : "" 
      )}
      aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
    >
      {collapsed ? <ChevronRight className="h-4 w-4" /> : <ChevronLeft className="h-4 w-4" />}
    </Button>
  );
};
